import { render, staticRenderFns } from "./appbar-component.vue?vue&type=template&id=59195818"
import script from "./appbar-component.vue?vue&type=script&lang=ts"
export * from "./appbar-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports